import { getBasenames } from './basename';

export type GetBasenameForUrlPath = (urlPath: string) => string | undefined;
export const getBasenameForUrlPath: GetBasenameForUrlPath = (urlPath) => {
  const basenames = getBasenames();

  return basenames.find((basename) => basename === urlPath || urlPath.startsWith(basename + '/'));
};
